(function () {
    'use strict';

    angular
        .module('app')
        .controller('MessagesController', MessagesController);

    MessagesController.$inject = ['$http', '$scope', '$rootScope', 'dateParser', '$stateParams', '$state', 'dialog'];

    function MessagesController($http, $scope, $rootScope, dateParser, $stateParams, $state, dialog) {
        $rootScope.header_inverted = false;
        $rootScope.dark_text_header = true;
        $rootScope.separate_page = false;
        $rootScope.hide_footer = false;
        $rootScope.dashboard = 'messages';
        var vm = this;
        vm.goToConversation = goToConversation;
        vm.pinConversation = pinConversation;
        vm.deleteConversation = deleteConversation;
        vm.hasSelectedConversations = hasSelectedConversations;
        vm.editMode = editMode;
        vm.archive = archive;
        vm.edit = false;

        vm.$onInit = function(){
            window.document.title = $stateParams.language == 'da' ? "Din profil - Beskeder - Be My Concert" : "Your profile - Messages - Be My Concert";
            getMessages();
        };

        function getMessages() {
            $http.get('api/messages/').then(function(response) {
                vm.conversations = response.data ? response.data : [];
            })
        }

        function pinConversation(conversation_id) {
            $http.post('api/pin_conversation/' + conversation_id).then(function(response) {
                getMessages();
            })
        }

        function goToConversation(conversation) {
            if(!vm.edit) {
                var request =  {conversation: conversation.conversation_id};
                if(conversation.affiliate_id) {
                    request.affiliate = conversation.affiliate_id;
                    request.recipient = conversation.other_slug;
                }
                $state.go('conversation', request);
            }

        }

        function editMode() {
            vm.edit = !vm.edit;
        }

        function getArchivedConversationIds() {
            var ids = [];
            vm.conversations.forEach(function (conversation) {
                if(conversation.archive == true)
                    ids.push(conversation.conversation_id);
            });
            return ids;
        }

        function hasSelectedConversations() {
            return getArchivedConversationIds().length > 0;
        }

        function archive() {
            $http.post('api/archive_conversations/', {
                    'conversation_ids': getArchivedConversationIds(),
                }).then(function (response) {
                    getMessages();
                });
        }

        // function deleteConversation(conversation_id) {
        //     var conversation = [];
        //     conversation.push(conversation_id)
        //     $http.post('api/archive_conversations/', {
        //             'conversation_ids': conversation,
        //         }).then(function (response) {
        //             getMessages();
        //         });
        // }

        function deleteConversation(conversation_id) {
            dialog.prompt('delete-message-prompt', function (response) {
                if (response.confirm) {
                    var conversation = [];
                    conversation.push(conversation_id)
                    $http.post('api/archive_conversations/', {
                        'conversation_ids': conversation,
                    }).then(function (response) {
                        getMessages();
                    });
                }
            });
        }

         $scope.$on('$destroy', function () {
            $rootScope.hide_footer = false;
        });
    }
})();
